<div class="warranty-eligible">
    <!-- header -->
    <div class="warranty-eligible-header mb-0">
        <div class="ui-g-12 flex-between-center p-0">
            <div class="flex-start-center width-100p">
                <div class="width-100p p-relative font-600 font-16 mt-1">
                    <i class="far fa-exclamation-triangle"></i>
                    {{itemTitle}}&nbsp;<span *ngIf="partNumber">({{partNumber}})</span>&nbsp;is
                    Warranty Eligible
                </div>
            </div>
            <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="handleClose(false)"></i>
        </div>
    </div>

    <!-- body -->
    <div class="warranty-eligible-body flex-column">
        <div class="ui-g-12 p-0 font-16 font-400">
            Is this part being installed for the first time or as a warranty
            replacement?
        </div>
        <ng-container *ngIf="!isLoading">
            <div class="ui-g-12 p-0 flex-row warranty-inner-wrapper">
                <div class="ui-g-6 p-0 flex-column warranty-option-section">
                    <app-radio-button [selectedValue]="warrantyEligible?.warrantyType" name="warrantyType"
                        [disabled]="invoicedRO" [ngClass]="{'not-allowed': invoicedRO }" label="First-Time Installation"
                        imgIcon="assets/img/icon/first-time-warranty.svg" imgIconClass="mr-1" value="first-time"
                        (appChange)="handleChange('warrantyType', $event)"></app-radio-button>
                    <label class="ml-5 lable-text">Applies to a new warranty eligible part that has not been previously
                        installed on this vehicle.</label>
                </div>
                <div class="ui-g-6 p-0 flex-column warranty-option-section">
                    <app-radio-button [selectedValue]="warrantyEligible?.warrantyType" name="warrantyType"
                        imgIcon="assets/img/icon/replacement-warranty.svg" imgIconClass="mr-1"
                        label="Warranty Replacement" value="replacement"
                        [disabled]="invoicedRO" [ngClass]="{'not-allowed': invoicedRO }"
                        (appChange)="handleChange('warrantyType', $event)"></app-radio-button>
                    <label class="ml-5 lable-text">For replacing a part that is eligible for warranty coverage due to
                        failure, defects or wear within the warranty period.</label>
                </div>
            </div>
            <div class="ui-g-12 p-0 flex-column warranty-being-replaced" style="height: 500px;"
                *ngIf="warrantyEligible?.warrantyType === 'replacement'">
                <!-- being replace section -->
                <div class="flex-column warranty-inner-replaced">
                    <div class="flex-row">
                        <app-radio-button [selectedValue]="warrantyEligible?.partWarrantyType" name="partWarrantyType"
                            styleClassLabel="font-14 font-600" label="Select part being replaced" value="being-replaced"
                            [disabled]="invoicedRO || warrantyEligible?.disableHistory"
                            (appChange)="handleChange('partWarrantyType', $event)"></app-radio-button>
                    </div>
                    <div class="flex-row warranty-parts">
                        <div class="flex-column warranty-parts-section w-100">
                            <!-- Table header -->
                            <div class="flex-row warranty-table-row">
                                <span class="ui-g-3 font-14 font-700">{{isWarrantyPartType ? 'Part':'Tire'}} Name</span>
                                <span class="ui-g-2 font-14 font-700">Part #</span>
                                <span class="ui-g-2 font-14 font-700" *ngIf="isWarrantyNumberAddonEnabled">Warranty
                                    #</span>
                                <span class="ui-g-2 font-14 font-700">Repair Order #</span>
                                <span class="ui-g-2 font-14 font-700">Invoice Date</span>
                                <span class="ui-g-2 font-14 font-700"></span>
                            </div>
                            <!-- Table rows -->
                            <div class="flex-row warranty-table-row" *ngFor="let partHistory of partWarrantiesHistory">
                                <span class="ui-g-3 font-14 font-400 text-truncate" tooltipPosition="top"
                                    [pTooltip]="partHistory?.partName">{{partHistory?.partName}}</span>
                                <span class="ui-g-2 font-14 font-400 text-truncate" tooltipPosition="top"
                                    [pTooltip]="partHistory?.partNumber">{{partHistory?.partNumber}}</span>
                                <span class="ui-g-2 font-14 font-400 text-truncate" tooltipPosition="top"
                                    [pTooltip]="partHistory?.warrantyNumber"
                                    *ngIf="isWarrantyNumberAddonEnabled">{{partHistory?.warrantyNumber}}</span>
                                <span class="ui-g-2 font-14 font-400 ">RO # {{partHistory?.code}}</span>
                                <span class="ui-g-2 font-14 font-400">{{partHistory?.invoiceDate | date : 'MMM d,
                                    yyyy'}}</span>
                                <span class="ui-g-2 font-14 font-400 p-0 flex-center-start">
                                    <button class="btn btn-white btn-submit"
                                        [disabled]="invoicedRO || warrantyEligible?.partWarrantyType !== 'being-replaced'"
                                        [ngClass]="{'btn-selected': partHistory?._id === warrantyEligible?.selectedPart?._id, 'not-allowed': warrantyEligible?.partWarrantyType !== 'being-replaced'}"
                                        (click)="selectUnSelectPart(partHistory)">
                                        <span class="font-700 font-14">{{ partHistory?._id ===
                                            warrantyEligible?.selectedPart?._id ? 'Selected' : 'Select'}}</span>
                                    </button>
                                </span>
                            </div>

                            <div class="warranty-table-row flex-center-center no-matching-ins"
                                *ngIf="!partWarrantiesHistory?.length">No matching warranty installations</div>

                        </div>
                    </div>
                </div>

                <!-- manually entered warranty -->
                <div class="flex-column warranty-inner-replaced" *ngIf="isWarrantyNumberAddonEnabled">
                    <div class="flex-row">
                        <app-radio-button [selectedValue]="warrantyEligible?.partWarrantyType" name="partWarrantyType"
                            styleClassLabel="font-14 font-600" label="Manually enter Warranty #"
                            value="manually-entered" [disabled]="invoicedRO"
                            (appChange)="handleChange('partWarrantyType', $event)"></app-radio-button>
                    </div>
                    <app-manual-enter-warranty [invoicedRO]="invoicedRO"
                        [isWarrantyNumberAddonEnabled]="isWarrantyNumberAddonEnabled"
                        [warrantyEligible]="warrantyEligible" openFrom="warranty" [error]="error" [data]="{
                            itemId: this.currentItemId,
                            customerId: this.customerId,
                            vehicleId: this.vehicleId
                        }" (warrantySave)="handleManualWarranty($event)"></app-manual-enter-warranty>

                </div>
            </div>
        </ng-container>
        <div class="flex-row flex-center-center" *ngIf="isLoading">
            <i class="fa fa-spinner rotate"></i>
        </div>
    </div>
    <div class="warranty-eligible-footer border-top-lightest">
        <div class="ui-g-6" *ngIf="warrantyEligible?.warrantyType === 'replacement' && isWarrantyPartType">
            <app-checkbox inputId="set-price-cost-zero" label="Set Cost and Price to $0.00"
                [isChecked]="warrantyEligible?.isSetCostPriceZero" [greenCheckbox]="true" [disabled]="invoicedRO"
                [ngClass]="{'not-allowed': invoicedRO }" (appChange)="handleChange('isSetCostPriceZero', $event)">
            </app-checkbox>
        </div>
        <div class="ui-g-6" *ngIf="warrantyEligible?.warrantyType === 'replacement' && !isWarrantyPartType">
            <app-checkbox inputId="set-price-cost-zero" label="Set Price to $0.00" [disabled]="invoicedRO"
                [ngClass]="{'not-allowed': invoicedRO }" [isChecked]="warrantyEligible?.isSetPriceZeroOnly"
                [greenCheckbox]="true" (appChange)="handleChange('isSetPriceZeroOnly', $event)">
            </app-checkbox>
        </div>
        <div class="ui-g-12 p-0 flex-end-center gap-2">
            <ng-container *ngIf="isMultipleItemsView && eligibleItems?.length > 1; else singleItemView">
                <span class="font-14 font-700 font-gray pointer" (click)="handleAction('skip')">Skip</span>
                <button class="btn btn-white font-700" [ngClass]="{'not-allowed': currentItemIndex <= 0}"
                    [disabled]="invoicedRO || currentItemIndex <= 0" (click)="handleAction('prev')">Previous</button>
                <span class="font-700 font-14 font-gray">{{currentItemIndex + 1}}/{{eligibleItems?.length}}</span>
                <button class="btn btn-primary font-700" [disabled]="isLoading || invoicedRO"
                    (click)="handleAction('next')"
                    *ngIf="eligibleItems?.length !== (currentItemIndex + 1)">Next</button>
                <button class="btn btn-primary font-700" [disabled]="isLoading || invoicedRO"
                    (click)="handleAction('confirm')"
                    *ngIf="eligibleItems?.length === (currentItemIndex + 1)">Confirm</button>
            </ng-container>
            <!-- <ng-container *ngIf="!isMultipleItemsView"> -->
            <ng-template #singleItemView>
                <button class="btn btn-white" (click)="handleClose(true)" [disabled]="invoicedRO"
                    [ngClass]="{'not-allowed': invoicedRO }">No Warranty</button>
                <button class="btn btn-primary" [disabled]="isLoading || invoicedRO"
                    [ngClass]="{'not-allowed': invoicedRO }" (click)="handleConfirm()">Confirm</button>
                <!-- </ng-container> -->
            </ng-template>

        </div>
    </div>
</div>